<app-modal [header]="'Editar os Dados da Ocorrência'"
           [isShow]="displayModal"
           [style]="'w-full max-w-lg'"
           (cancel)="displayModal = false; onCancelModalEmitter.emit()">

  <div class="mt-5">
    <app-event-form (onSubmitEvent)="onSubmit($event)"
                    [event]="event"
                    [apiErrors]="apiErrors"
                    [formStyle]="'w-full'"></app-event-form>
  </div>

</app-modal>
